import { RequestService } from '../../../../common/services/RequestService';
import { UPDATE_EMPLOYEE_STATUS } from '../constants';

export const updateEmployeeStatusRequest = async (idProfile, params) => {
  let url = UPDATE_EMPLOYEE_STATUS.replace('{profile_id}', idProfile)
    .replace('{employee_id}', params.employeeId)
    .replace('{profile_status_key}', params.status);
  const response = await RequestService.put(url);
  if (response.data && response.data.profileStatusId) {
    return {
      id: params.employeeId,
      data: {
        lastname: response.data.userId && response.data.userId.lastname,
        name: response.data.userId && response.data.userId.name,
        patronymic: response.data.userId && response.data.userId.patronymic,
        profileStatus: response.data.profileStatusId.profileStatus,
        profileStatusKey: response.data.profileStatusId.profileStatusKey,
      },
    };
  } else {
    throw new Error('Error status');
  }
};
